module.exports = __webpack_public_path__ + "static/img/waiting.4d15e31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/admin/waiting.png
// module id = OXDf
// module chunks = 2